import type {
  RestockWaitlistLineStatus,
  RestockWaitlistStatus,
} from "@/server/platform/db/schema/restock-waitlist";

export const RESTOCK_WAITLIST_STATUSES = [
  "waiting",
  "ready",
  "notified",
  "converted",
  "expired",
  "cancelled",
] as const satisfies readonly RestockWaitlistStatus[];

export const RESTOCK_WAITLIST_LINE_STATUSES = [
  "waiting",
  "ready",
  "fulfilled",
  "cancelled",
] as const satisfies readonly RestockWaitlistLineStatus[];

/** Blocks promoting the next waiting line for the same variant. */
export const RESTOCK_WAITLIST_LINE_BLOCKING_STATUSES = [
  "ready",
] as const satisfies readonly RestockWaitlistLineStatus[];

/** Line statuses that participate in FIFO queue ordering. */
export const RESTOCK_WAITLIST_LINE_QUEUE_STATUSES = [
  "waiting",
  "ready",
] as const satisfies readonly RestockWaitlistLineStatus[];

/** Entry statuses where lines can still block the variant queue. */
export const RESTOCK_WAITLIST_BLOCKING_ENTRY_STATUSES = [
  "waiting",
  "ready",
  "notified",
] as const satisfies readonly RestockWaitlistStatus[];

export const RESTOCK_WAITLIST_HOLD_DAYS = 3;

/** @deprecated use RESTOCK_WAITLIST_BLOCKING_ENTRY_STATUSES */
export const RESTOCK_WAITLIST_BLOCKING_STATUSES =
  RESTOCK_WAITLIST_BLOCKING_ENTRY_STATUSES;

/** @deprecated use line queue statuses */
export const RESTOCK_WAITLIST_QUEUE_STATUSES = [
  "waiting",
  "ready",
] as const satisfies readonly RestockWaitlistStatus[];

export const RESTOCK_WAITLIST_STATUS_LABELS: Record<
  RestockWaitlistStatus,
  string
> = {
  waiting: "ລໍຖ້າສິນຄ້າ",
  ready: "ພ້ອມແຈ້ງ",
  notified: "ແຈ້ງແລ້ວ · hold",
  converted: "ຂາຍແລ້ວ",
  expired: "ໝົດເວລາ",
  cancelled: "ຍົກເລີກ",
};
